import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Stack, Tooltip, Typography, useTheme } from "@mui/material";

import { LegendCard } from "@/Components/v2/atoms/Card";
import { LegendItem, LegendItemData } from "@/Components/v2/molecule/LegendItem/LegendItem";

export interface GroupedSatCurveLegendCardData {
  id: string;
  label: string;
  tooltip: string;
  isShown: boolean;
  isDisabled: boolean;
  data: LegendItemData[];
}

interface LegendCardProps {
  group: GroupedSatCurveLegendCardData | undefined;
  handleHideToggle: (id: string) => void;
  handleLegendItemClick: (id: string) => void;
}

export const GroupedSatCurveLegendCard: React.FC<LegendCardProps> = ({
  group,
  handleHideToggle,
  handleLegendItemClick,
}) => {
  const theme = useTheme();

  if (!group) return null;

  return (
    <LegendCard sx={{ width: "100%" }}>
      <Stack direction="row" spacing={1} paddingBottom={1} alignItems="center">
        <Typography fontWeight={600}>{group.label}</Typography>
        <Tooltip
          title={
            <Typography variant="body1" padding={1} sx={{ color: theme.palette.common.white }}>
              {group.tooltip}
            </Typography>
          }
          placement="bottom"
        >
          <HelpOutlineOutlinedIcon
            sx={{ color: theme.palette.brandedTypography.textColor, width: 16, height: 16 }}
          />
        </Tooltip>
        <Typography
          fontSize={12}
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => handleHideToggle(group.id)}
        >
          {!group.isDisabled && group.data.length > 0 && (group.isShown ? "Hide all" : "Show all")}
        </Typography>
      </Stack>

      <Stack direction="column" spacing={1} paddingTop={1}>
        {group.data.length ? (
          group.data.map((item) => (
            <LegendItem
              key={item.id}
              item={item}
              handleClick={() => handleLegendItemClick(item.id)}
            />
          ))
        ) : (
          <Typography variant="body2">None</Typography>
        )}
      </Stack>
    </LegendCard>
  );
};
